import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericDropdownComponent } from './generic-dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [ 
        GenericDropdownComponent
     ],
    imports: [ 
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        InputTextModule
     ],
    exports: [ 
        GenericDropdownComponent
     ],
    providers: [],
})
export class GenericDesplegableModule {}